import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

import CheckoutContainer from '../../components/checkoutContainer/CheckoutContainer';
import CheckoutForm from '../../components/checkoutInfo/checkoutForm/CheckoutForm';
import Header from './components/Header';

import data from '../../mocks/getPnrByIdResponse-roundtrip.json';

import OverviewSearchBar from '../../components/overviewSearchBar/OverviewSearchBar';
import AlertModalContainer from '../../components/alertModal/AlertModalContainer';
import FlightConfiormationModalContainer from '../../components/flightConfirmationModal/FlightConfiormationModalContainer';
import './PaymentChangePage.css';

import * as WhatTimeIsItService from '../../services/whatTimeIsIt/WhatTimeIsItService'
import AdyenService from '../../services/adyen/AdyenService'
import FeatureService from '../../services/feature/FeatureService';
import Features from '../../const/Features';

const I18n = require('i18n-react').default;

var AddPaymentURL = 'payment/api/v1/booking/adicional/card';
const DETAIL_PNR_URI = `/checkout/api/v2/booking/`;

const propTypes = {};

const AMEX = 'amex';

class PaymentChangePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      termIsChecked: false,
      isModalOpen: false,
      openModalInf: false,
      showConfirmationModal: false,
      checkoutInfo: {
        cardNumber: null,
        cardType: null,
        month: null,
        year: null,
        securityCode: null,
        name: null,
        cnpjCpf: null
      },
      amount: this.props.location.state.quotationJourney.values.totalTaxes,
      pnrNumber: this.props.location.state.pnrNumber,
      tudoAzulNumber: this.props.location.state.azulNumber,
      flightsFilter: this.props.location.state.flightsFilter,
      quotationJourney: this.props.location.state.quotationJourney
    };

    this.alterSearch = this.alterSearch.bind(this);
    this.toggleFlightConfirmationModal = this.toggleFlightConfirmationModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  toggleFlightConfirmationModal() {
    this.setState({
      showConfirmationModal: false
    });
    this.sendCard()
  }

  openModal() {
    this.setState({
      showConfirmationModal: true
    });
  }

  closeModal() {
    this.setState({
      showConfirmationModal: false
    });
  }

  alterSearch() {
    this.setState({
      isRedirect: true,
      pathname: '/',
      keepLoggedUser: this.callCenterMode()
    });
  }

  validate = () => {
    let isValidForm = true;
    this.cardForm.fields.forEach(field => {
      if (field.props.id === 'cardValidDate') {
        let isMonthValid = field.monthField.validate();
        if (!isMonthValid && isValidForm) {
          field.monthField.input.focus();
          isValidForm = false;
        }
        let isYearValid = field.yearField.validate();
        if (!isYearValid && isValidForm) {
          field.yearField.input.focus();
          isValidForm = false;
        }
        let isDateValid = field.validate();
        if (!isDateValid && isValidForm) {
          field.monthField.input.focus();
          isValidForm = false;
        }
      } else {
        let isFieldValid = field.validate();
        if (!isFieldValid && isValidForm) {
          field.input.focus();
          isValidForm = false;
        }
      }
    });
    return isValidForm;
  };

  getMaxLengthSecurityCode() {
    let maxLength = 4;
    if (this.state.checkoutInfo && this.state.checkoutInfo.cardType !== AMEX) {
      maxLength = 3;
    }
    return maxLength;
  }

  changeCreditCard = (value, type) => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        cardNumber: value,
        cardType: type
      }
    });
  };

  changeValidDate = (month, year) => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        month: month,
        year: year
      }
    });
  };

  changeSecurityCode = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        securityCode: value
      }
    });
  };

  changeName = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        name: value
      }
    });
  };

  changeCnpjCpf = value => {
    this.setState({
      checkoutInfo: {
        ...this.state.checkoutInfo,
        cnpjCpf: value
      }
    });
  };

  sendCard() {
    const isEnabledAdyenCardEncrypted = FeatureService.isFeatureEnabled((Features).ADYEN_CARD_ENCRYPTED);

    if (isEnabledAdyenCardEncrypted) {
      WhatTimeIsItService.get()
        .then(responseWhatTimeIsIt => {
          AdyenService.create(this.state.checkoutInfo, responseWhatTimeIsIt.currentTimestamp)
            .then(cardEncrypted => {
              const aPaymentRequest = {
                pnrNumber: this.state.pnrNumber,
                tudoAzulNumber: `${this.state.tudoAzulNumber}`,
                payment: {
                  cardEncrypted: "CtMGKcQ72Spb55jTisj1hvkiXhunTNwHa1O2SqORnGk=", // cardEncrypted,
                  vendorCode: this.state.checkoutInfo.cardType,
                  amount: this.state.amount,
                }
              };

              axios
                .post(AddPaymentURL, aPaymentRequest)
                .then(response =>
                  this.setState({
                    isRedirect: true,
                    urlRedirect: '/flightDetails'
                  })
                )
                .catch(err => {
                  this.showModal(I18n.translate('payment.msg.error'));
                });

            })
            .catch(error => {
              this.showModal(I18n.translate('payment.msg.error'));
            });
        })
        .catch(error => {
          this.showModal(I18n.translate('payment.msg.error'));
        });
    } else {
      const aPaymentRequest = {
        pnrNumber: this.state.pnrNumber,
        tudoAzulNumber: this.state.tudoAzulNumber,
        payment: {
          cardNumber: this.state.checkoutInfo.cardNumber,
          vendorCode: this.state.checkoutInfo.cardType,
          expiryMonth: this.state.checkoutInfo.month,
          expiryYear: this.state.checkoutInfo.year,
          cvv: this.state.checkoutInfo.securityCode,
          ccHolderName: this.state.checkoutInfo.name,
          document: this.state.checkoutInfo.cnpjCpf,
          amount: this.state.amount,
        }
      };

      axios
        .post(AddPaymentURL, aPaymentRequest)
        .then(response =>
          this.setState({
            isRedirect: true,
            urlRedirect: '/flightDetails'
          })
        )
        .catch(err => {
          this.showModal(I18n.translate('payment.msg.error'));
        });
    }
  }

  render() {
    const {
      cardNumber,
      cardType,
      month,
      year,
      securityCode,
      name,
      cnpjCpf
    } = this.state.checkoutInfo;

    const allDataInputed = cardNumber && cardType && month && year && securityCode && name && cnpjCpf;

    return (
      <div>
        <OverviewSearchBar
          origin={this.state.flightsFilter.flightOrigin.code}
          destination={this.state.flightsFilter.flightDestiny.code}
          departureDate={this.state.flightsFilter.startDate}
          returnDate={this.state.flightsFilter.endDate}
          totalAdults={this.state.flightsFilter.totalAdults}
          totalKids={this.state.flightsFilter.totalKids}
          totalBabys={this.state.flightsFilter.totalBabys}
          alterSearchCallback={this.alterSearch}
          alterFlightOverviewPrice={false} // true
          quotationJourney={this.state.quotationJourney}
          // history={this.props.history}
          steps={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetails',
            'features.breadcrumb.change',
            'features.breadcrumb.flightSelection',
            'features.breadcrumb.payment'
          ]}
          stepsBreadcrumb={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetail',
            'features.breadcrumb.change',
            'features.breadcrumb.flightSelection',
            'features.breadcrumb.payment'
          ]}
          actualStepBreadcrumb="features.breadcrumb.payment"
          ref={c => {
            this.overviewSearchBar = c;
          }}
          renderOpen={true}
        />
        <div id="FlightDetailsPage">
          <section className="section__outer section__outer">
            <Row>
              <Col md={12}>
                <Header />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <CheckoutForm
                  id="cardInformation"
                  securityCodeMaxLength={this.getMaxLengthSecurityCode()}
                  changeCreditCard={this.changeCreditCard}
                  changeValidDate={this.changeValidDate}
                  changeSecurityCode={this.changeSecurityCode}
                  changeName={this.changeName}
                  changeCnpjCpf={this.changeCnpjCpf}
                  ref={c => {
                    this.cardForm = c;
                  }}
                  sessionId="123456"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <CheckoutContainer
                  btnDisabled={!allDataInputed}
                  // eslint-disable-next-line react/prop-types
                  location={null}
                  isFormValid={this.validate}
                  proceedTo={() => '/'}
                  toggleModal={this.openModal}
                  {...this.state}
                  ref={c => (this.container = c)}
                />
              </Col>
            </Row>
          </section>
        </div>
        <FlightConfiormationModalContainer
          toggleFlightConfirmationModal={this.toggleFlightConfirmationModal}
          closeModal={this.closeModal}
          visible={this.state.showConfirmationModal}
        />
        <AlertModalContainer
          title={i18n.translate('message.paymentRefused').toString()}
          message={i18n.translate('message.cardRefused').toString()}
          visible={false}
          buttonText={i18n.translate('label.tryAgain').toString()}
          buttonColor="primary"
          closeModal={() => { }}
        />
        <AlertModalContainer
          title={i18n.translate('message.confirmExit').toString()}
          message={i18n.translate('message.exitWarning').toString()}
          visible={false}
          closeModal={() => { }}
        />
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                pnrNumber: this.state.pnrNumber
              }
            }}
          />
        ) : null}
      </div>
    );
  }
}

PaymentChangePage.propTypes = propTypes;

export default PaymentChangePage;



// WEBPACK FOOTER //
// ./src/page/paymentChange/PaymentChangePage.jsx